(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('validateCpf', ValidateCpf);

    function ValidateCpf(ValidatorHelper) {
        function verifyCpf(cpf) {
            return ValidatorHelper.validateCPF(cpf);
        }

        function link(scope, element, attrs, ctrl) {
            scope.$watch(attrs.ngModel, function (value) {
                if (verifyCpf(value))
                    ctrl.$setValidity('cpf', true);
                else
                    ctrl.$setValidity('cpf', false);
            })
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        }
    }
}());